import { CampaignStatus } from "@/modules/PhishingSimulations/store/types";

export const getCampaignStatusPillText = (status: CampaignStatus | unknown) => {
  switch (status) {
    case CampaignStatus.active:
      return "active";

    case CampaignStatus.planned:
      return "planned";

    case CampaignStatus.completed:
      return "completed";

    case CampaignStatus.deleted:
      return "deleted";

    default:
      return status;
  }
};

export const getCampaignStatusPillVariant = (
  status: CampaignStatus | unknown,
) => {
  if (status === CampaignStatus.active) {
    return "success";
  }

  if (status === CampaignStatus.planned) {
    return "info";
  }

  return "none";
};

export default {};
